import { JOVE_LOCAL_LOCALE_COUNTRY_KEY, initI18n, supportTranslationCountryConvertMap } from '@jove-frontend/uikit';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import common from './en/common.json';

export const initialI18n = (lng = 'en') => {
  initI18n({
    defaultNS: 'common',
    ns: ['common'],
    // uikit resources are merged in by initI18n; the dashboard only contributes its local `common` namespace
    resources: { en: { common } },
    lng,
  });
};

/**
 * Detect the initial language from the locally stored locale country.
 * Falls back to the default (en) during SSR where localStorage is unavailable.
 */
const detectInitialLanguage = () => {
  if (typeof window === 'undefined') return supportTranslationCountryConvertMap.DEFAULT.locale;
  const country = localStorage.getItem(JOVE_LOCAL_LOCALE_COUNTRY_KEY);
  return (country && supportTranslationCountryConvertMap[country]?.locale) || supportTranslationCountryConvertMap.DEFAULT.locale;
};

// Initialize synchronously at module scope so i18n is ready before any component renders.
// All locale resources are statically bundled, so init() completes immediately.
initialI18n(detectInitialLanguage());
